<template>
  <v-footer >
    <v-layout light wrap justify-center style="margin-bottom:50px">
      <v-flex xs12 sm12 md12 lg10 xl10 text-center>
        <v-layout wrap justify-center>
          <v-flex xs12 sm12 md4 lg3 xl2></v-flex>
          <v-flex style="padding-top:50px" xs12 lg9 xl10>
            <router-link to="/">
              <span class="AppHeading" style="color:#A8A8A8;">Web Peedika</span>
            </router-link>
          </v-flex>
          <v-flex xs12 sm12 md4 lg3 xl2></v-flex>
          <v-flex xs12 sm12 md4 lg3 xl2>
            <v-layout wrap>
              <v-flex>
                <span style="font-family: poppinssemibold;font-size:20px">Categories</span>
              </v-flex>
              <v-flex xs12 v-for="(item,i) in categories" :key="i">
                <router-link :to="item.route">
                  <span
                    style="font-family:poppinsregular;font-size:14px;color:#303030"
                  >{{item.name}}</span>
                </router-link>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md4 lg3 xl2>
            <v-layout wrap>
              <v-flex>
                <span style="font-family: poppinssemibold;font-size:20px">Customer Services</span>
              </v-flex>
              <v-flex xs12 v-for="(item,i) in services" :key="i">
                <router-link :to="item.route">
                  <span
                    style="font-family:poppinsregular;font-size:14px;color:#303030"
                  >{{item.name}}</span>
                </router-link>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md4 lg3 xl2>
            <v-layout wrap>
              <v-flex class="text-end">
                <span style="font-family: poppinssemibold;font-size:20px">Download</span>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex>
                <v-img src="./../../assets/images/gplay.png" width="80%" contain></v-img>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
      categories: [
        { name: "Fruits & Vegitables", route: "/" },
        { name: "Diary & Bakery", route: "/" },
        { name: "Staples", route: "/" },
        { name: "Snack & Branded Food", route: "/" },
        { name: "Beverage", route: "/" },
        { name: "Personal Care", route: "/" },
        { name: "Home Care", route: "/" },
        { name: "Baby Care", route: "/" },
        { name: "Medicines", route: "/" },
      ],
      services: [
        { name: "About Us", route: "/" },
        { name: "FAQ", route: "/" },
        { name: "Terms and conditions", route: "/" },
        { name: "Privacy policy", route: "/" },
      ],
    };
  },
};
</script>
<style scoped>
</style>